import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="site">
      <div className="wrap-wide">
        <div className="cols">
          <div className="brand-col">
            <Link className="brand" to="/">
              <img
                className="brand-logo"
                style={{ height: '56px' }}
                src="/atz-logo-white.png"
                alt="ATZ Solution"
              />
            </Link>
            <p className="fdesc">
              An independent professional services firm helping American small businesses
              register, certify, and stay compliant for federal contracting.
            </p>
          </div>
          <div className="fcol">
            <h4>Services</h4>
            <ul>
              <li>
                <Link to="/sam-registration/">SAM.gov Registration</Link>
              </li>
              <li>
                <Link to="/services/#certifications">SBA Certifications</Link>
              </li>
              <li>
                <Link to="/services/#services">Capability Statement</Link>
              </li>
              <li>
                <Link to="/services/#services">Bid &amp; Proposal Support</Link>
              </li>
              <li>
                <Link to="/services/#services">GSA Schedule Readiness</Link>
              </li>
            </ul>
          </div>
          <div className="fcol">
            <h4>Firm</h4>
            <ul>
              <li>
                <Link to="/about-us/">About</Link>
              </li>
              <li>
                <Link to="/portfolio/">Track Record</Link>
              </li>
              <li>
                <Link to="/services/">Our Process</Link>
              </li>
              <li>
                <Link to="/contact-us/">Contact</Link>
              </li>
            </ul>
          </div>
          <div className="fcol">
            <h4>Contact</h4>
            <ul>
              <li>
                <a href="tel:+17044598642">(704) 459-8642</a>
              </li>
              <li>
                <a href="mailto:presales@atzsolutionllc.com">presales@atzsolutionllc.com</a>
              </li>
              <li>
                <Link to="/contact-us/">Charlotte, NC</Link>
              </li>
              <li>
                <Link to="/contact-us/">Mon–Fri · 9:00–6:00 ET</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="disclaimer">
          <p>
            <span className="lead-d">
              ATZ Solution is a private consulting firm and is not a government agency.
            </span>{' '}
            We are not affiliated with, endorsed by, or sponsored by the U.S. government, the
            System for Award Management (SAM.gov), the U.S. Small Business Administration (SBA),
            the General Services Administration (GSA), or any other federal agency. Registration
            in SAM.gov is available at no cost directly through the U.S. government at SAM.gov.
            SBA certifications may also be obtained directly through the SBA at no cost. Fees
            charged by ATZ Solution are solely for optional professional advisory, preparation,
            and filing services. Use of this site does not create a client relationship and does
            not guarantee award of any federal contract, registration, or certification.
          </p>
        </div>

        <div className="legal">
          <small>© 2026 ATZ Solution, LLC. All rights reserved.</small>
          <div className="lks">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
